import React, { useEffect } from 'react'
import { Slice } from 'victory'

// Removing left corner radius for the second slice:
// make it start from the beginning of the half circle
const CustomSlice = ({
  setFirstSliceStartAngle,
  firstSliceStartAngle,
  index,
  slice,
  ...restProps
}) => {
  const { startAngle } = slice

  useEffect(
    () => {
      if (index === 0) {
        setFirstSliceStartAngle(startAngle)
      }
    },
    [setFirstSliceStartAngle, startAngle, index]
  )

  return (
    <Slice
      {...restProps}
      index={index}
      slice={{
        ...slice,
        startAngle: firstSliceStartAngle,
      }}
    />
  )
}

export default CustomSlice
